import React from "react";
import { useMatch } from "react-router-dom";

import { useUser } from "@js/apps/common/hooks";

import { WebSocketManagerContainer } from "../websocket";

type WebsocketManagerWrapperProps = {
  children: React.ReactNode;
};

export const WebsocketManagerWrapper = ({
  children,
}: WebsocketManagerWrapperProps) => {
  const user = useUser();
  const isCreateBidPage = useMatch("/jobs/:id/proposals/new");
  const shouldUseWebsockets = !!user || isCreateBidPage;

  if (!shouldUseWebsockets) {
    return <>{children}</>;
  }

  return <WebSocketManagerContainer>{children}</WebSocketManagerContainer>;
};
